((Drupal) => {
  const hideDonationActions = () =>
    document.body && document.body.classList.contains('hide-donation-actions');

  Drupal.behaviors.donate_button = {
    attach(context, settings) {

      const followButton = document.getElementById('block-followbutton');
      if (followButton) {
        followButton.addEventListener('load', () => {
          const donateButton = document.getElementById('XNDPFHNF');
          if (donateButton) {
            const buttonLabel = donateButton.querySelector('.button-label');
            if (buttonLabel) {
              buttonLabel.textContent = 'Donate Now';
            }
          }
        });
      }
    }
  };

  // Heartbeat animation for all donate buttons.
  Drupal.behaviors.donate_heartbeat = {
    attach(context, settings) {
      if (hideDonationActions()) return;
      // Do not start the animation until the page is done loading.
      window.addEventListener('load', () => {
        const hearts = document.querySelectorAll('.donate--animated svg');
        let scale = 1;
        let pulseSize = 1;
        let pulseFade = 0.2;

        function update() {
          const now = performance.now();
          scale = 1 + Math.sin(now / 300) * 0.08;
          if (pulseSize < 120) {
            pulseSize += 0.2;
            pulseFade -= 0.001;
          } else {
            pulseSize = 1;
            pulseFade = 0.2;
          }
          hearts.forEach((item) => {
            item.style.transform = `scale(${scale})`;
            item.parentElement.style.setProperty('--size', pulseSize);
            item.parentElement.style.setProperty('--opacity', pulseFade);
          });
          requestAnimationFrame(update);
        }
        update();
      });
    }
  };

  Drupal.behaviors.scroll = {
    attach(context, settings) {
      if (hideDonationActions()) return;
      window.onload = () => {
        const header = document.getElementById('js-header');
        if (header) {
          const headerOrgOffset = header.offsetTop + 40;

          document.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;

            if (currentScroll > headerOrgOffset) {
              header.classList.add('follow');
            } else {
              header.classList.remove('follow');
            }
          });

          // Passive scroll on touch devices
          const addPassiveEventListener = (event, handler) => {
            window.addEventListener(event, handler, { passive: true });
          };

          addPassiveEventListener('touchstart', () => { });
          addPassiveEventListener('touchmove', () => { });
          addPassiveEventListener('wheel', () => { });
          addPassiveEventListener('mousewheel', () => { });
        }
      };
    }
  };

  // MJ 3.18.26 - Per UNICEF-683, on Press Release content types if the field
  // 'hide donation actions' is checked, remove the persistent donate buttons through out the site.
  Drupal.behaviors.removeDonateActions = {
    attach() {
      const SELECTOR = 'iframe[title="Persistent Donate Button"]';
      const OBSERVER_KEY = '__sdHideDonationIframeObserver';

      const removeDonateIframes = () => {
        if (!hideDonationActions()) return;
        document.querySelectorAll(SELECTOR).forEach((iframe) => iframe.remove());
      };

      const disableLogoLink = () => {
        if (!hideDonationActions()) return;
        document.querySelectorAll('.logo a').forEach((logoLink) => {
          logoLink.removeAttribute('href');
          logoLink.style.pointerEvents = 'none';
          logoLink.style.cursor = 'default';
        });
      };

      const hideDonateLinks = () => {
        if (!hideDonationActions()) return;
        document.querySelectorAll('a.donate').forEach((link) => {
          link.style.display = 'none';
        });
      };

      const startObserver = () => {
        if (window[OBSERVER_KEY]) return;
        const observer = new MutationObserver(removeDonateIframes);
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'id', 'title'],
        });
        window[OBSERVER_KEY] = observer;
      };

      removeDonateIframes();
      disableLogoLink();
      hideDonateLinks();
      startObserver();
    },
  };
})(Drupal);
